import React from "react";
import PropTypes from "prop-types";
import { Box } from "@material-ui/core";

import TagText from "../../ui/Tags/TagText";

const CertificationsRenderer = ({ certifications = [] }) => {
  return (
    <Box display={"flex"} flexWrap={"wrap"} gridGap={"4px"}>
      {certifications.map(certification => {
        return (
          <TagText key={certification.name} intent={"primary"}>
            {certification.name}
          </TagText>
        );
      })}
    </Box>
  );
};
CertificationsRenderer.propTypes = {
  certifications: PropTypes.array,
};
export default CertificationsRenderer;
